import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import AddProgrammePage from "./AddProgrammePage";
import EditProgrammePage from "./EditProgrammePage";
import ProgrammeListingPage from "./ProgrammeListingPage";
import {
  withPermission,
  Roles,
} from "../../../util/PermissionProvider";

export default function ProgrammesManagementPage(props) {
  const { match } = props;
  return (
    <Switch>
      <Route
        exact
        path={`${match.url}`}
        component={withPermission(
          ProgrammeListingPage,
          [Roles.SUPERADMIN, Roles.HKNT_EDITOR, Roles.HKNT_VIEWER],
          [Roles.SUPERADMIN, Roles.HKNT_EDITOR]
        )}
      />
      <Route
        path={`${match.url}/create`}
        component={withPermission(
          AddProgrammePage,
          [Roles.SUPERADMIN, Roles.HKNT_EDITOR],
          [Roles.SUPERADMIN, Roles.HKNT_EDITOR]
        )}
      />
      <Route
        path={`${match.url}/edit/:id`}
        component={withPermission(
          EditProgrammePage,
          [Roles.SUPERADMIN, Roles.HKNT_EDITOR, Roles.HKNT_VIEWER],
          [Roles.SUPERADMIN, Roles.HKNT_EDITOR]
        )}
      />
      <Route render={() => <Redirect to={`${match.url}`} />} />
    </Switch>
  );
}
